<template>
    <div>
        <tr-text class="label" v-bind="props.label" :tracker="tracker"
                @edit-tr="$emit('edit-tr', $event)" v-if="showLabel" />
    </div>
</template>

<script>
import TrText from "@/components/translation/TrText"

export default {
    name:     "I18nText",
    components: {TrText},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style>
</style>